<div class="login-page">
  <div class="login-panel">

    <div class="brand">
      <img
        src="/logo_monitori_login.png"
        alt="Monitori"
        class="brand-logo"
      />
    </div>

    <h1 class="title">Login</h1>

    <p class="subtitle">
      Faça o login com sua conta Microsoft MONITORI
    </p>

    <!-- mensagem de erro -->
    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <button
      class="microsoft-button"
      type="button"
      (click)="onMicrosoftLogin()"
      [disabled]="isLoggingIn"
    >
      <div class="microsoft-card">
        <div class="microsoft-icon">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <span class="microsoft-label">
          {{ isLoggingIn ? 'Entrando...' : 'Microsoft' }}
        </span>
      </div>
    </button>

    <div class="separator">
      <span>ou continue com</span>
    </div>

    <button
      class="secondary-button"
      type="button"
      (click)="onLoginWithAnotherAccount()"
    >
      Login em outra conta
    </button>

  </div>
</div>